module.exports = __webpack_public_path__ + "img/hook_KITO_HJJ_2.69396d4c.png";